import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { Validator } from '@adornis/validation/validator.js';
import { sgNonOptional } from '@martinus/validation/sgNonOptional.js';

// TODO it is only used in the an-schwerbehinderung section. Migrate this to an address entity

@Entity()
export class ZipCity extends AdornisEntity {
  static override _class = 'ZipCity';

  @Field(type => String) zip: Maybe<string>;
  @Field(type => String) city: Maybe<string>;
  @Field(type => String) land: Maybe<string>;

  override toString() {
    return this.zip + ' ' + this.city;
  }
}

if (A.isClient) {
  const zipValidator = (location: string) => {
    switch (location) {
      case 'mitarbeiterDetails':
      case 'entryFormAnSchwerbehinderung':
        return options => {
          if (options.source.mitarbeiterDaten?.anSchwerbehinderung?.istVorhanden) {
            return sgNonOptional()(options);
          }
        };
    }
  };

  const cityValidator = (location: string) => {
    switch (location) {
      case 'mitarbeiterDetails':
      case 'entryFormAnSchwerbehinderung':
        return options => {
          if (options.source.mitarbeiterDaten?.anSchwerbehinderung?.istVorhanden) {
            return sgNonOptional()(options);
          }
        };
    }
  };

  ZipCity.prototype.validator = new Validator({
    zip: options => zipValidator(options.location)?.(options),
    city: options => cityValidator(options.location)?.(options),
  });
}
